import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import Accordion from "react-bootstrap/Accordion";
import { TextField } from "@material-ui/core";
import { Row, Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import Image from "react-bootstrap/Image";
import Alert from "react-bootstrap/Alert";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import EditModelBody from "./ItemAvailabilitytables/EditModelBody";
import ItemDescModelBody from "./ItemAvailabilitytables/ItemDescModelBody";
import Services from "../../vendorOnboradingComponents/allScreens/NewSubscriptionScreen/InsidePageScreen/CasualDiningManagementScreen/MenuSetup/AddItem/Services";
import moment from "moment";
import { useHistory } from "react-router-dom";
import {
  SET_ACTIVE_ITEM_ID_MENU_SETUP,
  BUSINESS_DETAILS_STEP,
} from "../../../store/types";
import {
  delete_item_from_category,
  get_menu_items,
  update_item_menu_setup,
} from "../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import ViewButtonPopup from "../../reusableComponents//allPopupReusable/ViewButtonPopup";
// import EditDiner from "../../reusableComponents/allPopupReusable/editDinerAndEditReservaion/EditDiner";
import { PopupIconButtonReusable } from "../../reusableComponents/allPopupReusable/allPopupReusableIconButton/PopupIconButtonReusable";
// import LocationReusable from "../../allPopupReusable/locationReusablePopup/LocationReusable";
// import EditWaitTime from "../../allPopupReusable/tableNumberPopup/EditWaitTime";
import DeletePopup from "../../reusableComponents/allPopupReusable/smallPopup/DeletePopup";
// import { NewCountDown } from "../../allPopupReusable/tableNumberPopup/NewCountDown";
import { Toggle } from "../../superAdminComponents/superAdminReusable/reusableSuperAdminButton/Toggle";
import {
  SwipeableList,
  SwipeableListItem,
} from "@sandstreamdev/react-swipeable-list";
import "@sandstreamdev/react-swipeable-list/dist/styles.css";
import { useDispatch, connect } from "react-redux";
import { ITEMTYPEVEG } from "../../../enums/OrderEnums";
import { NOTAVAILABLEIMAGE } from "../../../enums/GlobalEnums";

const ItemAvailabilityTableBody = (props) => {
  const [show, setShow] = useState(false);
  const [MrDetail, setMrDetail] = useState({ MrDetail: false });
  const viewOrderInDetail = () => setMrDetail({ MrDetail: !MrDetail.MrDetail });

  const [vtype, viewType] = useState(1);

  const onSuccess = () => {
    props.get_menu_items(props.token);
    handleCloseItemAvaiblity();
  };

  const dispatch = useDispatch();
  let history = useHistory();
  const [activeAvailablity, setActiveAvaiblity] = useState("");

  const availabilityStatus = [
    { name: "Available", id: "AVAILABLE", color: "green" },
    { name: "SoldOut", id: "SOLDOUT", color: "red" },
    { name: "Not Available", id: "NOTAVAILABLE", color: "black" },
  ];

  const changeAutoAccept = (status) => {
    const formData = {};

    formData.auto_accept = !status;

    props.update_item_menu_setup(
      props.item._id,
      formData,
      props.token,
      onSuccess
    );
  };

  const [showItemAvaiblity, setShowItemAvaiblity] = useState(false);

  const handleCloseItemAvaiblity = () => {
    setShowItemAvaiblity(false);
  };

  const handleShowItemAvaiblity = (id) => {
    setActiveAvaiblity(id);
    setShowItemAvaiblity(true);
  };

  const onClickUpdateItemAvaiblity = () => {
    const formData = {};
    formData.availability = activeAvailablity;
    props.update_item_menu_setup(
      props.item._id,
      formData,
      props.token,
      onSuccess
    );
  };

  const [showItem, setShowItem] = useState(false);
  const handleCloseShowItem = () => {
    setShowItem(false);
  };
  const handleshowItem = () => {
    setShowItem(true);
  };

  const onClickDeleteItem = () => {
    props.delete_item_from_category(
      props.item._id,
      props.token,
      onSuccessDelete
    );
  };

  const takeToEditPage = () => {
    dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: props.item._id });
    dispatch({ type: BUSINESS_DETAILS_STEP, payload: 3 });
    history.push("/additemavailablity");
  };

  const onSuccessDelete = () => {
    window.location.reload();
    Alert.success(`<h4>Item Deleted Sucessfully</h4>`, {
      position: "center",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    onSuccess();
  };

  const changeStatus = (status) => {
    const formData = {};
    if (status === undefined) {
      formData.status = false;
    } else {
      formData.status = !status;
    }
    props.update_item_menu_setup(
      props.item._id,
      formData,
      props.token,
      onSuccess
    );
  };

  const displayHealthTags = (itemHealthTags, categoryHealthTags) => {
    let result = categoryHealthTags.filter((o1) =>
      itemHealthTags?.some((o2) => o1._id === o2)
    );
    return result;
  };

  // const takeToEditPage = () => {
  //   dispatch({ type: SET_ACTIVE_ITEM_ID_MENU_SETUP, payload: props.item._id });
  //   history.push("/additemavailablity");
  // };

  return (
    // console.log(item)
    <React.Fragment>
      {/* <SwipeableList className={`swipe`}>
        {({ swipe, ...rest }) => (
          <div className={`${show ? "swipe" : ""}`}>
            <SwipeableListItem
              swipeLeft={{
                content: (
                  <div> */}

      {/* <div className="sectiontwo d-flex swipeOption">
                      <div className="p-1">
                        <Image
                          alt="wait"
                          title="wait"
                          width="10px"
                          height="13px"
                          src={require("../../../assets/images/UserManagement/wait.svg")}
                        />
                        <div className="f10-400 opacity5">Total Wait time</div>
                        <div className="f10-500">
                          {sendDataDinerProps.diner_status === "NOTSEATED"
                            ? time_convert(minutes)
                            : seated_time_difference(minutesSeated) ||
                              sendDataDinerProps.diner_status === "PENDING"
                            ? time_convert(minutes)
                            : seated_time_difference(minutesSeated)}
                        </div>
                      </div>
                      <div className="sectiontwo-left">
                        {displayButton.diner_status === "NOTSEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="resonFforCancellation"
                              buttonText="Cancel"
                              bigText="Are you sure to Cancel ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          </div>
                        ) : null || displayButton.diner_status === "SEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="seatingUnseated"
                              buttonText="Unseat"
                              bigText="Are you sure to Unseat ?"
                              dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null || displayButton === "pendingReject" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="resonFforCancellation"
                              buttonText="Reject"
                              bigText="Are you sure to Reject ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          </div>
                        ) : null ||
                          displayButton.diner_status === "COMPLETED" ||
                          displayButton.diner_status === "REJECTED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallCancelButton"
                              displayPopup="historyReset"
                              buttonText="Reset"
                              bigText="Are you sure to Reset ?"
                              dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null}
                      </div>

                      <div className="sectionthree-right">
                        {displayButton.diner_status === "NOTSEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="SeatedButton"
                              buttonText="Seat"
                              bigText="Are you sure to Seated ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          </div>
                        ) : null || displayButton.diner_status === "SEATED" ? (
                          <div>
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="seatingCompleted"
                              buttonText="Complete"
                              bigText="Are you sure to Completed ?"
                              dataSend={sendDataDinerProps}
                            />
                          </div>
                        ) : null || displayButtonTwo === "pendingAccept" ? (
                          sendDataDinerProps.service_type === "RESERVATION" ? (
                            sendDataDinerProps.service_type === "RESERVATION" &&
                            date4 < date1.getTime() ? (
                              ""
                            ) : (
                              <DeletePopup
                                buttonDisplay="smallSaveButton"
                                displayPopup="acceptButtonReservation"
                                buttonText="Accept"
                                bigText="Are you sure you want to accept ?"
                                dataSend={sendDataDinerProps}
                              />
                            )
                          ) : sendDataDinerProps.service_type === "SEATING" &&
                            date3 < date1.getDate() ? (
                            ""
                          ) : (
                            <DeletePopup
                              buttonDisplay="smallSaveButton"
                              displayPopup="acceptButton"
                              buttonText="Accept"
                              bigText="Are you sure you want to accept ?"
                              dataSend={sendDataDinerProps._id}
                            />
                          )
                        ) : // (
                        //   <DeletePopup
                        //     buttonDisplay="smallSaveButton"
                        //     displayPopup="acceptButton"
                        //     buttonText="Accept"
                        //     bigText="Are you sure you want to accept ?"
                        //     dataSend={sendDataDinerProps._id}
                        //   />
                        // )
                        null}
                      </div>
                    </div> */}
      {/* </div>
                ),
                action: () => setShow(true),
              }}
              swipeRight={{
                // content: <div>Revealed content during swipe</div>,
                action: () => setShow(false),
              }}
              {...rest}
            > */}
      <Card className="main-reusable-accordion">
        <Accordion.Toggle
          as={Card.Header}
          eventKey={props.indexKey + 1}
          // className={` ${
          //   sendDataDinerProps.service_type === "RESERVATION"
          //     ? "enLeftYellowLine"
          //     : "enLeftGReenLine"
          // }`}
          // className="enLeftGReenLine"
        >
          <div className="align-items-center row">
            <div className="col-3 p-0">
              <div className="">
                <div
                  className=" align-items-start"
                  style={{ textAlign: "center" }}
                >
                  {props.item?.image_thumbnails &&
                  props.item?.image_thumbnails[0] ? (
                    <img
                      src={props.item.image_thumbnails[0]}
                      width="32px"
                      heigth="32px"
                    />
                  ) : props.item?.images[0] ? (
                    <img
                      src={props.item.images[0]}
                      width="32px"
                      heigth="32px"
                    />
                  ) : (
                    <Image
                      src={NOTAVAILABLEIMAGE}
                      style={{
                        width: "32px",
                        height: "32px",
                        borderRadius: "5px",
                      }}
                      alt={"Item pic"}
                      title={
                        (props && props?.item && props?.item?.name) ||
                        "Item pic"
                      }
                    />
                  )}
                  <br />
                  <div
                    style={{
                      fontSize: "8px",
                      fontWeight: "500",
                      marginLeft: "5px",
                    }}
                  >
                    #ID{" "}
                    {props && props.item && props.item.ext_id
                      ? props.item.ext_id
                      : props.item._id}
                  </div>
                </div>
              </div>
            </div>
            <div className="col-3 p-0">
              <div className="f10-500">
                {ITEMTYPEVEG.map((type, index) => {
                  return (
                    <React.Fragment key={index}>
                      {props?.item?.itemType === type?.value ? (
                        <img
                          width="20px"
                          src={type.url}
                          alt={type.title}
                          title={type.title}
                          fluid
                        />
                      ) : null}
                    </React.Fragment>
                  );
                })}{" "}
                &nbsp; {props.item && props.item.name}
                <hr className="mt-1 mb-1 m-0" />
                <Image
                  src={
                    props &&
                    props?.item &&
                    props?.item?.primary_food_type &&
                    props?.item?.primary_food_type?.icon
                  }
                  alt={
                    props &&
                    props?.item &&
                    props?.item?.primary_food_type &&
                    props?.item?.primary_food_type?.title
                  }
                  title={
                    props &&
                    props?.item &&
                    props?.item?.primary_food_type &&
                    props?.item?.primary_food_type?.title
                  }
                  width="20px"
                  fluid
                />{" "}
                {props.item &&
                  props.item.primary_food_type &&
                  props.item.primary_food_type.title}
              </div>
            </div>
            <div className="col-3 p-0">
              <div
                className={
                  //dinnerOrderType === "waitlist" ||
                  // dinnerOrderType === "reservation" ||
                  // status === "seated" ||
                  // status === "pending"
                  //   ? "card-header-middle"
                  "card-header-middle"
                }
                onClick={(e) => {
                  if (!e) var e = window.event;
                  e.cancelBubble = true;
                  if (e.stopPropagation) e.stopPropagation();
                }}
              >
                <div className="d-flex align-items-center">
                  <div className="f10-500 mr-1">No</div>
                  <Toggle
                    checked={props.item && props.item.auto_accept}
                    toggleFunction={() =>
                      changeAutoAccept(props.item.auto_accept)
                    }
                    className="tog_mv"
                    // toggleFunction={toggleFunction}
                  />
                  <div className="f10-500  ml-1">Yes</div>
                </div>
              </div>
            </div>
            <div className="col-3 p-0">
              <div
                className={
                  // dinnerOrderType === "waitlist" ||
                  // dinnerOrderType === "reservation" ||
                  // status === "SEATED" ||
                  // status === "NOTSEATED" ||
                  // status === "PENDING" ||
                  // status === "REJECTED" ||
                  // status === "COMPLETED"
                  //   ? "card-header-right justify-content-center"
                  "card-header-right "
                }
                onClick={(e) => {
                  if (!e) var e = window.event;
                  e.cancelBubble = true;
                  if (e.stopPropagation) e.stopPropagation();
                }}
              >
                <div
                  onClick={() =>
                    handleShowItemAvaiblity(props.item.availability)
                  }
                  //className="badge  badge-danger"
                  id="mobile_view_badge"
                  className={`${
                    props.item && props.item.availability === "AVAILABLE"
                      ? " badge badge-success"
                      : props.item && props.item.availability === "SOLDOUT"
                      ? " badge badge-danger"
                      : " badge badge-dark mobile_notavilable_button"
                  }`}
                  style={{ padding: "5px 10px", borderRadius: "10px" }}
                >
                  {props.item && props.item.availability}
                </div>
              </div>
            </div>
          </div>
        </Accordion.Toggle>
        <Accordion.Collapse eventKey={props.indexKey + 1}>
          <Card.Body>
            {/******* Section One *********/}
            <hr className="mt-0" />
            <div className="row">
              <div className="col-6  sectionone-left">
                <div className="row">
                  <p
                    className="f12-400 pb-3 opacity5"
                    style={{ paddingLeft: "8px" }}
                  >
                    More Actions
                  </p>{" "}
                  <br />
                </div>
                <div className="more-actions-orders-desc  align-items-center pb-3  mb-2 row">
                  {/* <SuperAdminCall /> */}
                  <Button
                    variant="link"
                    className="enIconBtn mr-3"
                    onClick={() => {
                      viewType(1);
                      viewOrderInDetail();
                    }}
                  >
                    <Image
                      src={require("../../../assets/images/UserManagement/eye.svg")}
                      alt="View"
                      title="View"
                      fluid
                    />
                  </Button>
                  <Button
                    variant="link"
                    className="enIconBtn mr-3"
                    // onClick={() => {
                    //   viewType(2);
                    //   viewOrderInDetail();
                    // }}
                    onClick={() => takeToEditPage()}
                  >
                    <Image
                      src={require("../../../assets/images/UserManagement/pencil.svg")}
                      alt="Edit"
                      title="Edit"
                      fluid
                    />
                  </Button>{" "}
                  <Button
                    variant="link"
                    className="enIconBtn mr-3"
                    onClick={() => handleshowItem()}
                    // onClick={() => {
                    //   viewType(1);
                    //   viewOrderInDetail();
                    // }}
                  >
                    <Image
                      src={require("../../../assets/images/UserManagement/Delete.svg")}
                      alt="Delete"
                      title="Delete"
                      fluid
                    />
                    {/* <i
                                class="fa fa-trash"
                                style={{ color: "#000000" }}
                                title="Delete"
                              ></i> */}
                  </Button>
                  {/* <CustomSuperAdminNotification
                              _id={"5f84b0d7741561060859ee1f"}
                            /> */}
                </div>
              </div>
              <div
                className="col-3 sectionone-middle border-right border-left"
                style={{ marginBottom: "10px" }}
              >
                <p className="f12-400 pb-2 opacity5">Item Category</p>

                {props &&
                  props.item &&
                  props.item.tags &&
                  props.item.tags.map((tag, index) => (
                    <p className="f12-400" key={index}>
                      {" "}
                      {tag.title} {index + 1 !== props.item.tags.length && ", "}
                    </p>
                  ))}
              </div>
              <div
                className="col-3 sectionone-right"
                style={{ marginBottom: "10px" }}
              >
                <p className="f12-400 pb-2 opacity5">Item Availability</p>
                <p className="f12-400 text-blue">Lunch</p>
              </div>
            </div>
            <hr className="mt-0" />
            <div className="row">
              <div
                className="col-5  sectionone-left border-left"
                style={{ marginBottom: "10px" }}
              >
                <p className="f12-400 pb-2 opacity5">Active Services</p>
                <p className="d-flex f12-400 text-blue">
                  {[
                    {
                      status:
                        props?.subscriptionStatus?.ordering?.take_away?.value,
                      name: props?.item?.take_away?.value,
                      value: "Take Away",
                    },
                    {
                      status:
                        props?.subscriptionStatus?.ordering?.cubside_delivery
                          ?.value,
                      name: props?.item?.curb_side?.value,
                      value: "Curb Side",
                    },
                    {
                      status:
                        props?.subscriptionStatus?.ordering?.self_serve?.value,
                      name: props?.item?.skip_line?.value,
                      value: "Skip The Line",
                    },
                    {
                      status:
                        props?.subscriptionStatus?.ordering?.dine_in_order
                          ?.value,
                      name: props?.item?.dine_in?.value,
                      value: "Dine In",
                    },
                    {
                      status: false,
                      name: false,
                      value: "Buffet",
                    },
                    {
                      status:
                        props?.subscriptionStatus?.ordering?.catering_banquet
                          ?.value,
                      name: props?.item?.catering_banquet?.value,
                      value: "Catering",
                    },
                    {
                      status: false,
                      name: false,
                      value: "Drive Thru",
                    },
                    {
                      status:
                        props?.subscriptionStatus?.ordering?.home_delivery
                          ?.value,
                      name: props?.item?.home_delivery?.value,
                      value: "Home Delivery",
                    },
                  ].map((data, index) => {
                    if (data.status) {
                      if (index === 0) {
                        return data.value;
                      } else if (data.name) {
                        return ", " + data.value;
                      }
                    }
                  })}
                  {/* {props.item.curb_side.value ? (
                                "Curb Side ,"
                              ) : (
                                <> </>
                              )}
                              {props.item.dine_in.value ? "Dine-In ," : <> </>}
                              {props.item.take_away.value ? (
                                "Take Away ,"
                              ) : (
                                <> </>
                              )}
                              {props.item.skip_line.value ? (
                                "Skip The Line ,"
                              ) : (
                                <> </>
                              )} */}
                  &nbsp;
                  {/* <Button
                                variant="link"
                                className="enIconBtn mr-3"
                                onClick={() => {
                                  viewType(3);
                                  viewOrderInDetail();
                                }}
                              >
                                <Image
                                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                                  alt="Edit"
                                  title="Edit"
                                  fluid
                                />
                              </Button>{" "} */}
                </p>
              </div>
              <br />
              <div
                className="col-4 sectionone-middle border-right border-left"
                style={{ marginBottom: "10px" }}
              >
                <p className="f12-400 pb-2 opacity5">Description</p>
                <p className="f12-400">
                  {props.item && props.item.description}
                </p>
              </div>
              <br />
              <div
                className="col-3 sectionone-right"
                style={{ marginBottom: "10px" }}
              >
                <p className="f12-400 pb-2 opacity5">Cuisine Type</p>
                <p className="f12-400">
                  {props.item &&
                    props.item.cuisin_type &&
                    props.item.cuisin_type.title}
                </p>
              </div>
              <br />
            </div>
            <hr className="mt-0" />
            <div className="row">
              <div
                className="col-3  sectionone-left border-left"
                style={{ marginBottom: "10px" }}
              >
                <p className="f12-400 pb-2 opacity5">Status</p>
                <p>
                  {props.item && props.item.status === undefined
                    ? "Active"
                    : props.item && props.item.status
                    ? "Active"
                    : "In Active"}
                  &nbsp;
                  <Toggle
                    checked={
                      props.item && props.item.status === undefined
                        ? true
                        : props.item && props.item.status
                        ? true
                        : false
                    }
                    toggleFunction={() => changeStatus(props.item.status)}
                  />
                </p>
              </div>
              <div
                className="col-3 sectionone-middle border-right border-left"
                style={{ marginBottom: "10px" }}
              >
                <p className="f12-400 pb-2 opacity5">Customizable</p>
                <p className="f12-400 text-blue">
                  {props.item &&
                    props.item.addOns &&
                    props.item.addOns.map((addon, index) => (
                      <p className="f12-400 text-blue" key={index}>
                        {addon.name}{" "}
                      </p>
                    ))}
                </p>
              </div>
              <div
                className="col-3 sectionone-middle border-right border-left"
                style={{ marginBottom: "10px" }}
              >
                <p className="f12-400 pb-2 opacity5">No. Of Views</p>
                <p className="f12-400">
                  <Image
                    src={require("../../../assets/images/UserManagement/eye.svg")}
                    alt="View"
                    title="View"
                    fluid
                    style={{ paddingRight: "3px" }}
                  />
                  {props.item && props.item.view_count}
                </p>
              </div>
              <div
                className="col-3 sectionone-right"
                style={{ marginBottom: "10px" }}
              >
                <p className="f12-400 pb-2 opacity5">Item Ordered</p>
                <p className="f12-400">
                  <Image
                    src={require("../../../assets/images/Orders/icons/itemOrders.svg")}
                    alt="View"
                    title="View"
                    style={{
                      paddingRight: "3px",
                      width: "18px",
                      maxWidth: "100%",
                      height: "auto",
                    }}
                  />
                  {props.item && props.item.order_count}
                </p>
              </div>
            </div>
            <br />
            <hr className="mt-0" />
            <div
              className="justify-content-center"
              style={{ marginBottom: "10px" }}
            >
              <p className="f12-400 pb-2 opacity5">Item Tag</p>
              <p className="f12-400">
                {props &&
                  props.item &&
                  props.item.tags &&
                  props.item.tags.map((tag, index) => (
                    <Fragment key={index}>
                      {" "}
                      {tag.title} {index + 1 !== props.item.tags.length && ", "}
                    </Fragment>
                  ))}
              </p>
            </div>
            <hr />
            <div
              className="justify-content-center"
              style={{ marginBottom: "10px" }}
            >
              <p className="f12-400 pb-2 opacity5">Health Tag</p>
              <p className="f12-400">
                {displayHealthTags(
                  props?.item?.healthTags || [],
                  props?.healthTags
                ).map((tag, index) => {
                  return (
                    <Fragment key={index}>
                      {tag.title}
                      {index + 1 !== props?.item?.healthTags.length && ", "}
                    </Fragment>
                  );
                })}
              </p>
            </div>
            <hr className="mt-0" />
            <div className="row p pl-4">
              <p className="f12-500">Item Sizes</p>
            </div>
            <div className="row">
              <div
                className="col-3 border-left"
                style={{ textAlign: "center" }}
              >
                <p className="f12-400 pb-2 opacity5">Available</p>
              </div>
              <div
                className="col-3  border-right border-left"
                style={{ textAlign: "center" }}
              >
                <p className="f12-400 pb-2 opacity5">Size</p>
              </div>
              <div
                className="col-3 sectionone-middle border-right border-left "
                style={{ textAlign: "center" }}
              >
                <p className="f12-400 pb-2 opacity5">Price</p>
              </div>
              <div
                className="col-3 sectionone-right"
                style={{ textAlign: "center" }}
              >
                <p className="f12-400 pb-2 opacity5">Servicing PAX</p>
              </div>
            </div>
            {props.item &&
              props.item.size.map((size, index) => (
                <div className="row" key={index}>
                  <div className="col-3">
                    <Toggle
                      checked={size.available}
                      //checked={false}
                      disabled={true}
                    />
                  </div>
                  <div className="col-3" style={{ textAlign: "center" }}>
                    <p className="f12-400">{size.description}</p>
                  </div>
                  <div className="col-3" style={{ textAlign: "center" }}>
                    <p className="f12-400">₹ {size.price}</p>
                  </div>
                  <div className="col-3" style={{ textAlign: "center" }}>
                    <p className="f12-400">{size.pax}</p>
                  </div>
                </div>
              ))}
            <div>
              <Modal
                show={MrDetail.MrDetail}
                onHide={() => {
                  viewOrderInDetail();
                }}
                centered
                size="lg"
              >
                <Modal.Header className="border-0 pl-4" closeButton>
                  <Modal.Title className="f24-700">
                    Item Availability Details
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4 f16-500">
                  <div className="">
                    {vtype === 1 && (
                      <ItemDescModelBody
                        takeToEditPage={takeToEditPage}
                        handleshowItem={handleshowItem}
                        item={props && props.item}
                      />
                    )}
                    {vtype !== 3 && vtype !== 1 && <EditModelBody />}
                    {vtype === 3 && (
                      <div className="new-subscription-onboarding-component">
                        <Row>
                          <Col xs={8}>
                            <TextField
                              variant="outlined"
                              label="Item Name"
                              fullWidth
                            />
                          </Col>
                        </Row>
                        <Services onChange={() => {}} origin={"edit"} />
                      </div>
                    )}

                    {/* {vtype === 3 && <OrderLocation />} */}
                  </div>
                  {/* <EditUser
                            data={currentUserData}
                            CloseEdit={handleCloseEdit}
                          /> */}
                </Modal.Body>
              </Modal>
            </div>
          </Card.Body>
        </Accordion.Collapse>
      </Card>
      {/* </SwipeableListItem> */}
      {/* </div> */}
      {/* )}
      </SwipeableList> */}
      <React.Fragment>
        <Modal show={showItem} onHide={handleCloseShowItem} centered>
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title>Delete item</Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            Are you sure to delete this Item ?
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={handleCloseShowItem}
            >
              No
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              // onClick={handleCloseBlockUser}
              onClick={() => onClickDeleteItem()}
            >
              Yes
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>

      <React.Fragment>
        <Modal
          show={showItemAvaiblity}
          onHide={handleCloseItemAvaiblity}
          centered
        >
          <Modal.Header className="py-0 pt-2 border-0" closeButton>
            <Modal.Title> Availability Status</Modal.Title>
          </Modal.Header>
          <Modal.Body className="f16-500">
            {" "}
            Select one relevant options from below
            <div className="container">
              <div className="row ">
                {availabilityStatus.map((availablity, index) => (
                  <div className="col-6 p-2" key={index}>
                    <div
                      className={` p-2 ${
                        availablity.id === activeAvailablity &&
                        `sts_sld_btn_box_a`
                      }`}
                      onClick={() => setActiveAvaiblity(availablity.id)}
                      style={{
                        backgroundColor: `${availablity.color}`,
                        borderRadius: "5px",
                        color: "white",
                      }}
                      align="center"
                    >
                      {availablity.name}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="justify-content-start border-0">
            <Button
              variant="outline-secondary"
              className="btn-lg mr-4 px-5"
              onClick={handleCloseItemAvaiblity}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              className="btn-lg px-5"
              // onClick={handleCloseBlockUser}
              onClick={() => onClickUpdateItemAvaiblity()}
            >
              Confirm
            </Button>
          </Modal.Footer>
        </Modal>
      </React.Fragment>
    </React.Fragment>
  );
};

ItemAvailabilityTableBody.propTypes = {
  auth: PropTypes.object.isRequired,
  update_item_menu_setup: PropTypes.func.isRequired,
  get_menu_items: PropTypes.func.isRequired,
  delete_item_from_category: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  allergy_info: state.category && state.category.allergy_info,
  menuCategoryItems: state.onboarding && state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding && state.onboarding.activeItemId,
  healthTags: state.category && state.category.health_tags,
  subscriptionStatus: state?.onboarding?.onboard_subscription_details
    ?.casual_dining
    ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
    : state?.onboarding?.onboard_subscription_details?.fast_food_dining
    ? state?.onboarding?.onboard_subscription_details?.fast_food_dining_status
    : state?.onboarding?.onboard_subscription_details?.multi_service_business
    ? state?.onboarding?.onboard_subscription_details
        ?.multi_service_business_status
    : {},
});

// export default ItemAvailabilityTableBody;

export default connect(mapStateToProps, {
  update_item_menu_setup,
  get_menu_items,
  delete_item_from_category,
})(ItemAvailabilityTableBody);
